import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)
const _hoisted_2 = { class: "flex items-center justify-end space-x-4" }
const _hoisted_3 = { class: "md:inline !moblands:hidden hidden text-16m font-medium text-wrh-gray-600" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "w-full block t-16r text-wrh-gray-medium" }, " Change Home ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "w-full block t-16r text-wrh-gray-medium" }, " Log Out ", -1)

import {
  ref, computed, onMounted, watch,
} from 'vue';
import {
  getAuth, signOut, User,
} from 'firebase/auth';
import { useRouter } from 'vue-router';
import {
  Menu, MenuItems, MenuItem, MenuButton,
} from '@headlessui/vue';
import { onClickOutside } from '@vueuse/core';
import { Modals, Routes, StoreActions } from '@/constants';
import { useAuth, getUserAvatar } from '@/util/funcs';
import { Homebuyer, IPartialHomeBuyer, ReqHomesDocument } from '@/models';
import Logout from '@/components/icons/LogoutIcon.vue';
import Chevron from '@/components/icons/ChevronIcon.vue';
import HomeIcon from '@/components/icons/HomeIcon.vue';
import UserAvatar from './UserAvatar.vue';
import Modal from './Modal.vue';
import HeaderSkeleton from '@/components/skeleton/HeaderSkeleton.vue';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userMenu = ref(null);
const modalData = Modals.SignOut;
const isVisibleModal = ref(false);
const router = useRouter();
const user = ref<User | null>(null);
const isEmailVerified = ref(false);
const multipleHomes = ref(true);
const loading = ref(false);
const closeMenu = ref(false);

onClickOutside(userMenu, (event) => {
  closeMenu.value = false;
});

const homeBuyer = computed(() => store.getters.homebuyer as Homebuyer);

const displayName = computed(() => {
  if (Object.keys(homeBuyer.value).length) {
    return `${homeBuyer.value.firstName} ${homeBuyer.value.lastName}`;
  }
  return '';
});

const homes = computed(() => store.getters.allHomes as ReqHomesDocument[]);

onMounted(async () => {
  loading.value = true;
  const auth = await useAuth();
  user.value = auth.user.value;
  isEmailVerified.value = auth.isEmailVerified.value;
  if (homes.value.length < 2) {
    multipleHomes.value = false;
  }
  loading.value = false;
});

const moveToLogin = () => {
  localStorage.clear();
  router.push({ name: Routes.LOGIN });
};

const signOutUser = async () => {
  store.dispatch(StoreActions.CLEAR_STORE);
  signOut(getAuth()).then(async () => {
    moveToLogin();
  }).catch((err) => {
    moveToLogin();
  });
};

const changeHomeRedirect = () => {
  router.push({
    name: Routes.HOMES,
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!!user.value && !loading.value && _unref(displayName))
      ? (_openBlock(), _createBlock(_unref(Menu), {
          key: 0,
          onMouseup: _cache[1] || (_cache[1] = ($event: any) => (closeMenu.value = !closeMenu.value)),
          ref: (_value, _refs) => {
            _refs['userMenu'] = _value
            userMenu.value = _value
          },
          as: "div",
          class: "relative z-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MenuButton), {
              class: _normalizeClass(["max-w-xs flex items-center text-sm rounded-xl bg-white md:p-3 shadow-modal !moblands:p-0 md:pr-3 focus:outline-none", {'cursor-not-allowed': !isEmailVerified.value}]),
              disabled: !isEmailVerified.value
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(UserAvatar, {
                    user: _unref(getUserAvatar)(_unref(homeBuyer).firstName, _unref(homeBuyer).lastName),
                    class: "h-8 w-8 md:h-10 md:w-10"
                  }, null, 8, ["user"]),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(displayName)), 1),
                  _createVNode(Chevron, { class: "w-6 h-6 !moblands:hidden hidden md:block" })
                ])
              ]),
              _: 1
            }, 8, ["class", "disabled"]),
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "transform opacity-0 scale-95",
              "enter-to-class": "transform opacity-100 scale-100",
              "leave-active-class": "transition ease-in duration-75",
              "leave-from-class": "transform opacity-100 scale-100",
              "leave-to-class": "transform opacity-0 scale-95"
            }, {
              default: _withCtx(() => [
                (closeMenu.value)
                  ? (_openBlock(), _createBlock(_unref(MenuItems), {
                      key: 0,
                      static: true,
                      class: "origin-top-right absolute right-0 mt-2 !moblands:w-[185px] w-[185px] md:w-full rounded-xl shadow-modal bg-white py-2 focus:outline-none",
                      as: "ul"
                    }, {
                      default: _withCtx(() => [
                        (multipleHomes.value)
                          ? (_openBlock(), _createBlock(_unref(MenuItem), {
                              key: 0,
                              as: "li"
                            }, {
                              default: _withCtx(({ active }) => [
                                _createElementVNode("div", {
                                  class: _normalizeClass([[
                active ? 'bg-gray-100' : '',
                'flex items-center py-2 px-4 cursor-pointer',
              ], ""]),
                                  onMouseup: changeHomeRedirect
                                }, [
                                  _createVNode(HomeIcon, { class: "w-7 h-7 mr-5 text-wrh-gray-medium" }),
                                  _hoisted_4
                                ], 34)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(MenuItem), {
                          onMouseup: _cache[0] || (_cache[0] = ($event: any) => (isVisibleModal.value = !_unref(store).getters.isLoginAsAdmin))
                        }, {
                          default: _withCtx(({ active }) => [
                            _createElementVNode("div", {
                              class: _normalizeClass([[
                active ? 'bg-gray-100' : '',
                'flex items-center py-2 px-4 cursor-pointer mt-2',
              ], ""])
                            }, [
                              _createVNode(Logout, { class: "w-7 h-7 mr-5 text-wrh-gray-medium" }),
                              _hoisted_5
                            ], 2)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true),
    (loading.value || !_unref(displayName).length)
      ? (_openBlock(), _createBlock(HeaderSkeleton, { key: 1 }))
      : _createCommentVNode("", true),
    (isVisibleModal.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 2,
          modalData: _unref(modalData),
          onConfirm: signOutUser,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (isVisibleModal.value = false))
        }, null, 8, ["modalData"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})